import React, { useContext, useEffect, useMemo, useState } from "react";

import { Table, Button, Form, Spinner, Badge } from "react-bootstrap";

import axios from "../context/AxiosInstance";

import Navbar from "../components/Navbar";

import AppBreadcrumb from "../components/AppBreadcrumb";

import Sidebar from "../components/Sidebar";

import { AuthContext } from "../context/AuthContext";

import CreerComptePersonnelModal from "../components/utilisateur/CreerComptePersonnelModal";

import RenvoyerInvitationModal from "../components/utilisateur/RenvoyerInvitationModal";

import RhKpiCard from "../components/common/RhKpiCard";

import RhTablePagination from "../components/common/RhTablePagination";

import { FaUserShield, FaSearch, FaUserPlus, FaEnvelope } from "react-icons/fa";

import "../styles/rh-modern-ui.css";



const PersonnelAdminPage = () => {

  const { token, role } = useContext(AuthContext);



  const [users, setUsers] = useState([]);

  const [search, setSearch] = useState("");

  const [loading, setLoading] = useState(true);

  const [unauthorized, setUnauthorized] = useState(false);



  const [showCreateModal, setShowCreateModal] = useState(false);

  const [showResendModal, setShowResendModal] = useState(false);

  const [selectedUser, setSelectedUser] = useState(null);



  const [currentPage, setCurrentPage] = useState(1);

  const [perPage, setPerPage] = useState(25);



  const canManage = role === "ADMIN" || role === "RH";



  const fetchUsers = async () => {

    setLoading(true);

    if (!canManage) {

      setUnauthorized(true);

      setLoading(false);

      return;

    }

    try {

      const res = await axios.get("/personnel/liste/", {

        headers: { Authorization: `Bearer ${token}` },

      });

      const data = Array.isArray(res.data?.data) ? res.data.data : [];

      setUsers(data);

    } catch (err) {

      if (err?.response?.status === 403) setUnauthorized(true);

      console.error("Erreur chargement utilisateurs (personnel):", err);

    } finally {

      setLoading(false);

    }

  };



  useEffect(() => {

    if (token && role) fetchUsers();

    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [token, role]);



  const filtered = useMemo(() =>

    users.filter((u) =>

      `${u.nom || ""} ${u.prenom || ""} ${u.login || ""} ${u.email || ""}`

        .toLowerCase()

        .includes(search.toLowerCase())

    ),

  [users, search]);



  const kpis = useMemo(() => {

    const actifs = users.filter((u) => u.is_active).length;

    const inactifs = users.length - actifs;

    const avecEmail = users.filter((u) => u.email).length;

    return { total: users.length, actifs, inactifs, avecEmail };

  }, [users]);



  const currentData = filtered.slice((currentPage - 1) * perPage, currentPage * perPage);



  return (

    <div className="d-flex">

      <Sidebar />

      <div className="main-content w-100">

        <Navbar />

        <div className="container-fluid p-4 p-lg-5 rh-page-content">

          <AppBreadcrumb items={[{ label: "Accueil", to: "/" }, { label: "Personnel" }]} />



          <header className="rh-page-header d-flex flex-wrap justify-content-between align-items-start gap-3">

            <div>

              <h4>

                <span className="rh-page-icon"><FaUserShield /></span>

                Comptes Personnel

              </h4>

              <p>Création et suivi des accès à l&apos;espace personnel des employés.</p>

            </div>

            {canManage && (

              <Button className="rh-btn-primary" onClick={() => setShowCreateModal(true)}>

                <FaUserPlus /> Créer compte(s)

              </Button>

            )}

          </header>



          {loading ? (

            <div className="rh-loading-block">

              <Spinner animation="border" />

              <p className="mt-3 mb-0">Chargement…</p>

            </div>

          ) : unauthorized ? (

            <div className="rh-alert-unauth">

              Accès restreint : seuls ADMIN et RH peuvent consulter cette section.

            </div>

          ) : (

            <>

              <div className="rh-kpi-grid">

                <RhKpiCard label="Comptes" value={kpis.total} variant="primary" />

                <RhKpiCard label="Actifs" value={kpis.actifs} variant="success" />

                <RhKpiCard label="Inactifs" value={kpis.inactifs} variant="neutral" />

                <RhKpiCard label="Avec email" value={kpis.avecEmail} variant="info" />

              </div>



              <div className="rh-toolbar">

                <div className="rh-toolbar-left">

                  <div className="rh-search-wrap">

                    <FaSearch className="rh-search-icon" />

                    <Form.Control

                      type="text"

                      placeholder="Nom, prénom, login, email…"

                      value={search}

                      onChange={(e) => setSearch(e.target.value)}

                    />

                  </div>

                  <span className="rh-result-pill">{filtered.length} résultat{filtered.length !== 1 ? "s" : ""}</span>

                </div>

              </div>



              <div className="rh-table-panel">

                <div className="table-responsive">

                  <Table hover className="rh-modern-table mb-0">

                    <thead>

                      <tr>

                        <th>Nom</th>

                        <th>Prénom</th>

                        <th>Login</th>

                        <th>Email</th>

                        <th>Type</th>

                        <th>Statut</th>

                        <th>Dernière connexion</th>

                        {canManage && <th className="text-center">Actions</th>}

                      </tr>

                    </thead>

                    <tbody>

                      {currentData.length === 0 ? (

                        <tr>

                          <td colSpan={canManage ? 8 : 7} className="text-center text-muted py-4">Aucun compte trouvé.</td>

                        </tr>

                      ) : (

                        currentData.map((u) => (

                          <tr key={u.id_user}>

                            <td><strong>{u.nom}</strong></td>

                            <td>{u.prenom}</td>

                            <td>{u.login}</td>

                            <td>{u.email || "—"}</td>

                            <td><span className="rh-badge rh-badge-indigo">{(u.type_compte || "").toUpperCase()}</span></td>

                            <td>

                              {u.is_active ? (

                                <span className="rh-badge rh-badge-green">Actif</span>

                              ) : (

                                <span className="rh-badge rh-badge-slate">Inactif</span>

                              )}

                            </td>

                            <td>{u.date_derniere_connexion ? new Date(u.date_derniere_connexion).toLocaleString() : "—"}</td>

                            {canManage && (

                              <td>

                                <div className="rh-row-actions">

                                  <Button

                                    size="sm"

                                    variant="outline-primary"

                                    className="rh-action-btn"

                                    onClick={() => { setSelectedUser(u); setShowResendModal(true); }}

                                  >

                                    <FaEnvelope /> Renvoyer

                                  </Button>

                                </div>

                              </td>

                            )}

                          </tr>

                        ))

                      )}

                    </tbody>

                  </Table>

                </div>

                <RhTablePagination

                  currentPage={currentPage}

                  totalItems={filtered.length}

                  perPage={perPage}

                  onPageChange={setCurrentPage}

                  onPerPageChange={(n) => { setPerPage(n); setCurrentPage(1); }}

                  itemLabel="comptes"

                />

              </div>

            </>

          )}

        </div>



        <CreerComptePersonnelModal show={showCreateModal} onHide={() => setShowCreateModal(false)} onSuccess={() => { setShowCreateModal(false); fetchUsers(); }} />

        <RenvoyerInvitationModal show={showResendModal} onHide={() => setShowResendModal(false)} user={selectedUser} />

      </div>

    </div>

  );

};



export default PersonnelAdminPage;

